// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fQ","advertDetailServiceList__header":"c-o_fR","advertDetailServiceList__list":"c-o_fS"};